import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { usePagesTranslation } from "../locales";

/** Homepage section inviting tutors to `/tutors`. */
export default function LandingEducatorSection() {
    const { t } = usePagesTranslation();

    return (
        <section className="pi-section" id="tutors" aria-labelledby="pi-edu-title">
            <div className="pi-landing__inner">
                <header className="pi-section__head pi-edu__head">
                    <p className="pi-hero__eyebrow">
                        <span className="pi-hero__eyebrow-dot" aria-hidden />
                        {t("educators.home-badge", "Tutor's crossword")}
                    </p>
                    <h2 className="pi-section__title" id="pi-edu-title">
                        {t(
                            "educators.home-headline",
                            "Make a crossword from your content",
                        )}
                    </h2>
                    <p className="pi-section__subtitle">
                        {t(
                            "educators.home-subtitle",
                            "Paste a lesson, a paragraph, or the words you want to teach. We turn that text into a private crossword. Print it and use it offline, or play it online in the browser.",
                        )}
                    </p>
                </header>

                <div className="pi-edu__actions">
                    <RouterLink className="pi-btn pi-btn--brand pi-edu__btn" to="/tutors">
                        {t("educators.home-cta-primary", "Learn more")}
                    </RouterLink>
                </div>
            </div>
        </section>
    );
}
